import { BreadcrumbItem } from '@/components/Breadcrumb/Breadcrumb'
import { useEffect, useState } from 'react'

export function BreadcrumbJSONSchema({
  breadcrumbs,
}: {
  breadcrumbs?: BreadcrumbItem[]
}) {
  const [pageOrigin, setPageOrigin] = useState<string>()

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setPageOrigin(window.location.origin)
    }
  }, [])

  const jsonData = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumbs.map((breadcrumb, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: breadcrumb.title,
      item: { '@id': pageOrigin + breadcrumb.url, '@type': 'WebPage' },
    })),
  }

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(jsonData),
      }}
    />
  )
}
